const PRO_PLAN_CODE = 'professional';
const Views = self => ({
    get proPlan() {
        return self.plans.find(plan => plan.code === PRO_PLAN_CODE) || null;
    },
    get proMonthlyPrices() {
        const plan = self.proPlan;
        if (!plan) {
            return [];
        }
        return plan.prices.filter(price => price.interval.unit === 'month' && price.active);
    },
    get proAnnualPrices() {
        const plan = self.proPlan;
        if (!plan) {
            return [];
        }
        return plan.prices.filter(price => price.interval.unit === 'year' && price.active);
    },
    get proSeatProducts() {
        return self.seatProducts.find(sp => sp.planCode === PRO_PLAN_CODE) || null;
    },
    get proFeatures() {
        var _a, _b;
        if (!self.pricingPlanFeatures) {
            return [];
        }
        const groups = self.pricingPlanFeatures.plan_groups;
        let currentGroup = null;
        groups.forEach(group => {
            if (parseFloat(self.pricingVersion) >= parseFloat(group.version_min) &&
                parseFloat(self.pricingVersion) <= parseFloat(group.version_max)) {
                currentGroup = group;
            }
        });
        if (!currentGroup) {
            return [];
        }
        const proPlan = (_a = currentGroup.plans) === null || _a === void 0 ? void 0 : _a.find(({ plan_name }) => plan_name === PRO_PLAN_CODE);
        return (_b = proPlan === null || proPlan === void 0 ? void 0 : proPlan.features) !== null && _b !== void 0 ? _b : [];
    },
});
export default Views;
